import { FirestoreDataConverter } from "firebase/firestore";
import { map } from "lodash";
import moment from "moment";
import PosicaoInternacional from "../models/posicaoInternacional";
import PosicaoAtivoInternacional from "../models/posicaoAtivoInternacional";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class PosicaoInternacionalDb extends BaseDb<
  PosicaoInternacional,
  { usuarioId: string; posicaoId: string }
> {
  _path: string = "usuarios/usuarioId/posicoesInternacional/posicaoId";

  getConverter(): FirestoreDataConverter<PosicaoInternacional> {
    return {
      fromFirestore: (snapshot, _options) =>
        new PosicaoInternacional({
          data: moment(snapshot.get("data").toDate()),
          posicoes: map(snapshot.get("posicoes"), PosicaoAtivoInternacional.fromFirestore),
        }),
      toFirestore: toFirestore,
    };
  }
}